export const shouldShowSessionWarning = (expiresAt, nowSeconds, lastWarnedExpiry) => {
  const secondsLeft = Math.ceil(Number(expiresAt || 0) - nowSeconds);
  return secondsLeft > 0 && secondsLeft <= 300 && lastWarnedExpiry !== Number(expiresAt);
};
